import { i18n } from '@/commons/utils';

export function B2CBlock() {
  this.init = function init(params) {
    this.container = params.container;
    this.parent = params.parent;
    this.onExpressConfirmation = params.onExpressConfirmation;

    this.props = {
      id: this.container.getAttribute('data-payment-type-id'),
      multiEnabled: this.container.getAttribute('data-multi-enabled'),
      orderId: params.orderId,
      isCheckout: params.isCheckout || false,
      isExpress: params.isExpress || false
    };

    this.state = {
      selected: params.selected || false
    };

    this.elements = {};
    if (this.props.isExpress === false) {
      this.elements.header = this.container.querySelector('.dkt-block-header');
      this.elements.content = this.container.querySelector('.dkt-block-content');
    } else {
      this.elements.content = this.container;
    }

    if (this.elements.content) {
      this.render();
    }

    this.events();

    if (this.state.selected === true) {
      this.select();
    }

  };
}

B2CBlock.prototype.render = function render() {
  this.elements.content.innerHTML = `<p class="dkt-description">${i18n('payment.primary.description.MANUAL_-_BANK_TRANSFER_B2C')}</p>`;
};

B2CBlock.prototype.events = function events() {
  if (this.props.isCheckout === true) {
    this.elements.header.addEventListener('click', this.select.bind(this));
  }
  document.addEventListener('clickedOnPay', this.check.bind(this));
  document.addEventListener('PrimaryPaymentBlockSelected', this.unselect.bind(this));
};

B2CBlock.prototype.check = function check() {
  if (this.state.selected === true) {
    if (this.props.isCheckout === true) {
      if (this.parent.checkTermsOfUse() === false) return;
      if (this.parent.checkBillingAddress && this.parent.checkBillingAddress() === false) return;
      if (this.parent.isFullSecondaryPayment && this.parent.isFullSecondaryPayment() === true) return;
    }
    this.submitPayment();
  }
};

B2CBlock.prototype.select = function select(event) {
  if ((this.state.selected === false && event) || !event) {
    document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
      bubbles: false,
      cancelable: false,
      detail: {
        'multiEnabled': this.props.multiEnabled
      }
    }));

    this.container.className += ' dkt-block--selected dkt-block--open';
    this.state.selected = true;
    this.parent.enableButton();
  }
};

B2CBlock.prototype.unselect = function unselect() {
  this.container.classList.remove('dkt-block--selected');
  this.container.classList.remove('dkt-block--open');
  this.state.selected = false;
};

B2CBlock.prototype.submitPayment = function submitPayment() {
  const params = {
    orderId: this.props.orderId,
    paymentTypeId: this.props.id,
    redirectionUrl: document.getElementById('redirectionUrl').value,
    orderAttributes: JSON.stringify(this.parent.getAnalyticsInfos())
  };

  params.useSecondaryMop = $('[data-role=secondary-payment-block]').hasClass('dkt-block--open');

  if (this.parent.displayLoader) {
    this.parent.displayLoader();
  }
  cube.ajax.post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
    .onSuccess(this.submitPaymentSuccess.bind(this))
    .call();
};

B2CBlock.prototype.submitPaymentSuccess = function submitPaymentSuccess(response) {
  if (response && response.result && response.result.data) {
    const data = response.result.data;
    if (window.cube.config.anly_useLegacy === 'Y') {
      CUBE.Analytics.queue.send('proceedToConfirmation');
    }

    if (data.paymentModifiable === 'false') {
      window.location.reload();
    }

    if (data.redirectConfirmation === 'true') {
      window.location.href = data.redirectionUrl;
    }

    if (data.reloadExpressCartridge && data.reloadExpressCartridge === 'true') {
      this.onExpressConfirmation(data.redirectConfirmation);
    }
  } else {
    if (this.parent.hideLoader) {
      this.parent.hideLoader();
    }
    if (this.parent.displayError) {
      this.parent.displayError(response.responseTO.errors[0].message);
    }
  }
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-b2c.js